// Copyright (c) 2022 Deere & Company

import actions from '../../actions-list';

export const updateOverrideAccount = account => ({
    overrideAccount: account,
    type: actions.UPDATE_OVERRIDE_CLOSE_ACCOUNT
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/update-override-close-account.js